import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from '@repo/ui-primitives/button';
import { cn } from '@repo/ui-primitives/utils';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
/**
 * Zephyr Pagination component.
 */ const Pagination = (param)=>{
    let { className, count, page, showFirstButton, showLastButton, onChange } = param;
    if (count < 2) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    const handlePageChange = (newPage)=>{
        if (newPage >= 1 && newPage <= count && newPage !== page) {
            onChange(newPage);
        }
    };
    const getPageNumbers = ()=>{
        const pages = [];
        const maxVisible = 7;
        const startPage = Math.max(1, page - 1);
        const endPage = Math.min(count, page + 1);
        if (count <= maxVisible) {
            for(let i = 1; i <= count; i++){
                pages.push(i);
            }
        } else {
            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) {
                    pages.push('ellipsis-start');
                }
            }
            for(let i = startPage; i <= endPage; i++){
                pages.push(i);
            }
            if (endPage < count) {
                if (endPage < count - 1) {
                    pages.push('ellipsis-end');
                }
                pages.push(count);
            }
        }
        return pages;
    };
    return /*#__PURE__*/ _jsxs("nav", {
        className: cn('flex items-center justify-center gap-1', className),
        "aria-label": "pagination",
        children: [
            showFirstButton && /*#__PURE__*/ _jsx(Button, {
                variant: "outline",
                size: "icon-sm",
                onClick: ()=>handlePageChange(1),
                disabled: page === 1,
                "aria-label": "First page",
                children: /*#__PURE__*/ _jsx(ChevronsLeft, {
                    className: "size-4"
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "outline",
                size: "icon-sm",
                onClick: ()=>handlePageChange(page - 1),
                disabled: page === 1,
                "aria-label": "Previous page",
                children: /*#__PURE__*/ _jsx(ChevronLeft, {
                    className: "size-4"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center gap-1",
                children: getPageNumbers().map((pageNum, index)=>{
                    if (pageNum === 'ellipsis-start' || pageNum === 'ellipsis-end') {
                        return /*#__PURE__*/ _jsx("span", {
                            className: "px-2 py-1 text-sm text-muted-foreground",
                            children: "..."
                        }, "ellipsis-".concat(index));
                    }
                    const pageNumber = pageNum;
                    const isActive = pageNumber === page;
                    return /*#__PURE__*/ _jsx(Button, {
                        variant: isActive ? 'default' : 'outline',
                        size: "sm",
                        onClick: ()=>handlePageChange(pageNumber),
                        "aria-label": "Page ".concat(pageNumber),
                        "aria-current": isActive ? 'page' : undefined,
                        children: pageNumber
                    }, pageNumber);
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "outline",
                size: "icon-sm",
                onClick: ()=>handlePageChange(page + 1),
                disabled: page === count,
                "aria-label": "Next page",
                children: /*#__PURE__*/ _jsx(ChevronRight, {
                    className: "size-4"
                })
            }),
            showLastButton && /*#__PURE__*/ _jsx(Button, {
                variant: "outline",
                size: "icon-sm",
                onClick: ()=>handlePageChange(count),
                disabled: page === count,
                "aria-label": "Last page",
                children: /*#__PURE__*/ _jsx(ChevronsRight, {
                    className: "size-4"
                })
            })
        ]
    });
};
export { Pagination };
